import BundleResultItem from "@app/react/components/BundleResultItem/BundleResultItem.jsx";

export default function BundleResultItems({bundles, configurationLink=false, pageLink=false, datasheetLink=false, linkToProduct = false, itemsClassName = null}) {
  return bundles.map(bundle => <BundleResultItem key={bundle.id} bundle={bundle} className={itemsClassName} configurationLink={configurationLink} pageLink={pageLink} datasheetLink={datasheetLink} linkToProduct={linkToProduct} />)
}
